import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApiQuery, useApiPost } from '../../../../api/hooks';
import { useSmenaGamesStore } from '../../../../stores';
import { SHIFT_GAMES } from './gamesModel';

// Карточка «Игры смены»: тумблеры активации игр для смены.
export default function ShiftGamesCard({ smenaId }) {
    const setGames = useSmenaGamesStore(state => state.setGames);
    const setGameActive = useSmenaGamesStore(state => state.setGameActive);

    const { data: games, isLoading, refetch } = useApiQuery(
        ['smena', smenaId, 'games'],
        `/api/camps/admin/smena/${smenaId}/games`
    );

    useEffect(() => {
        if (games) setGames(games);
    }, [games, setGames]);

    const activateGame = useApiPost({ successMessage: 'Игра активирована', withPreloader: true, onSuccess: () => refetch() });
    const deactivateGame = useApiPost({ successMessage: 'Игра деактивирована', withPreloader: true, onSuccess: () => refetch() });

    const isToggling = activateGame.isPending || deactivateGame.isPending;

    const isGameActive = (gameType) => games?.find(g => g.gameType === gameType)?.active || false;

    const handleToggle = (gameType, shouldActivate) => {
        const action = shouldActivate ? 'activate' : 'deactivate';
        setGameActive(gameType, shouldActivate);
        const mutation = shouldActivate ? activateGame : deactivateGame;
        mutation.mutate({ url: `/api/camps/admin/smena/${smenaId}/games/${gameType}/${action}` });
    };

    return (
        <section className="set-card">
            <h2>Игры смены</h2>
            <div className="lead">Активируйте игры, которые будут доступны участникам в этой смене</div>
            <div className="gm-grid">
                {SHIFT_GAMES.map(({ type, label, description, Icon, disabled }) => {
                    const active = isGameActive(type);
                    return (
                        <button
                            type="button"
                            key={type}
                            className={`gm${active ? ' on' : ''}`}
                            onClick={() => handleToggle(type, !active)}
                            disabled={isLoading || isToggling || disabled}
                            title={disabled ? 'Игра ещё не готова' : undefined}
                        >
                            <span className="gic"><Icon /></span>
                            <div className="gtx">
                                <div className="gn">{label}</div>
                                <div className="gd">{description}</div>
                            </div>
                            <span className="sw" />
                        </button>
                    );
                })}
            </div>
        </section>
    );
}

ShiftGamesCard.propTypes = {
    smenaId: PropTypes.number.isRequired
};
